import React from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import {
  IconCheckCircle, IconDroplet, IconFileText, IconLeaf, IconPin, IconCloud,
} from '../components/Icons';
import './servicios/ServicePage.css';

const SERVICES = [
  {
    id: 'icas',
    Icon: IconCheckCircle,
    title: 'ICAS – Informe de Cumplimiento Ambiental',
    desc: 'Elaboramos el Informe de Cumplimiento de las Obligaciones Ambientales (ICAS) requerido por las corporaciones autónomas regionales y el ANLA, en los términos y plazos establecidos en las licencias ambientales, planes de manejo y permisos concedidos.',
    details: [
      'Recopilación y análisis de datos ambientales del periodo',
      'Verificación del cumplimiento de todas las obligaciones',
      'Monitoreo de calidad del aire, agua y suelo',
      'Elaboración de indicadores de gestión ambiental',
      'Identificación de no conformidades y medidas correctivas',
      'Presentación ante CORPOBOYACÁ, CAR u otra autoridad',
    ],
    norm: 'Ley 99 de 1993 – Decreto 2820 de 2010',
  },
  {
    id: 'estudios-aguas',
    Icon: IconDroplet,
    title: 'Estudios de Aguas',
    desc: 'Realizamos estudios hidrológicos e hidrogeológicos completos para la caracterización, uso y manejo sostenible del recurso hídrico superficial y subterráneo en áreas de influencia de proyectos mineros y de infraestructura.',
    details: [
      'Caracterización fisicoquímica y microbiológica de fuentes hídricas',
      'Aforos y medición de caudales superficiales',
      'Evaluación de impactos sobre el recurso hídrico',
      'Estudios de calidad de aguas subterráneas',
      'Diseño de sistemas de tratamiento de aguas residuales',
      'Monitoreo de redes de calidad hídrica requeridas',
    ],
    norm: 'Decreto 1076 de 2015 – Resolución 0631 de 2015',
  },
  {
    id: 'licencias',
    Icon: IconFileText,
    title: 'Licencias Ambientales',
    desc: 'Acompañamos a nuestros clientes en todo el proceso de obtención, modificación y seguimiento de licencias ambientales ante el ANLA y corporaciones autónomas regionales, desde el diagnóstico inicial hasta la aprobación final.',
    details: [
      'Elaboración del Estudio de Impacto Ambiental (EIA)',
      'Diagnóstico Ambiental de Alternativas (DAA)',
      'Elaboración de términos de referencia',
      'Acompañamiento en audiencias públicas ambientales',
      'Trámites ante ANLA y corporaciones autónomas',
      'Modificación, actualización y seguimiento post-licencia',
    ],
    norm: 'Ley 99/1993 – Decreto 2041 de 2014',
  },
  {
    id: 'pma',
    Icon: IconLeaf,
    title: 'PMA – Plan de Manejo Ambiental',
    desc: 'Elaboramos Planes de Manejo Ambiental integrales para proyectos mineros y de infraestructura, incluyendo todos los programas de manejo requeridos por la autoridad ambiental competente.',
    details: [
      'Caracterización ambiental del área de influencia',
      'Identificación y evaluación de impactos (matrices)',
      'Programas: flora, fauna, suelos, agua, aire, comunidades',
      'Plan de contingencia ambiental',
      'Indicadores de seguimiento y monitoreo',
      'Programa de compensación y restauración ecológica',
    ],
    norm: 'Decreto 1076/2015 – Resolución ANLA',
  },
  {
    id: 'huella-carbono',
    Icon: IconCloud,
    title: 'Huella de Carbono',
    desc: 'Cuantificamos las emisiones de gases de efecto invernadero (GEI) de proyectos mineros e industriales en los Alcances 1, 2 y 3, formulamos estrategias de reducción y acompañamos el reporte ante el SIRE del Ministerio de Ambiente y Desarrollo Sostenible.',
    details: [
      'Inventario de emisiones GEI: Alcances 1, 2 y 3',
      'Cuantificación según GHG Protocol e ISO 14064-1',
      'Identificación de fuentes fijas, móviles y fugitivas',
      'Factores de emisión nacionales e internacionales actualizados',
      'Plan de reducción y estrategias de compensación',
      'Reporte ante el SIRE – Ministerio de Ambiente',
    ],
    norm: 'GHG Protocol – ISO 14064 – Resolución 2202/2016 MADS',
  },
];

export default function EnvironmentalServices() {
  return (
    <div>
      <PageHero
        title="Servicios Ambientales"
        subtitle="Gestión ambiental responsable: cumplimiento normativo, estudios técnicos y licencias ante autoridades ambientales."
        variant="blue"
      />

      <section className="section">
        <div className="container">
          <div className="svc-intro">
            <div className="svc-intro__text">
              <div className="divider divider--blue" />
              <h2 className="section-title">Gestión Ambiental Responsable</h2>
              <p>
                El componente ambiental es fundamental en cualquier proyecto minero. Acompañamos a
                nuestros clientes en el cumplimiento de todas sus obligaciones ante el <strong>ANLA</strong>,{' '}
                <strong>CORPOBOYACÁ</strong> y demás corporaciones autónomas regionales, asegurando
                que cada intervención en el territorio sea ambientalmente responsable.
              </p>
              <p>
                Nuestros profesionales ambientales cuentan con experiencia en la elaboración de
                documentos técnicos para proyectos de minería de carbón, obras de infraestructura y
                manejo de recursos naturales.
              </p>
            </div>
            <div className="svc-norm-card">
              <h3>Autoridades ante las que tramitamos</h3>
              <ul>
                <li>ANLA</li>
                <li>CORPOBOYACÁ</li>
                <li>CAR Cundinamarca</li>
                <li>Corporaciones Autónomas Regionales</li>
                <li>Alcaldías y entes territoriales</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--bg">
        <div className="container">
          <div className="divider divider--blue" />
          <h2 className="section-title">Nuestros Servicios Ambientales</h2>
          <div className="svc-list">
            {SERVICES.map(({ id, Icon, title, desc, details, norm }) => (
              <div key={id} className="svc-item">
                <div className="svc-item__icon svc-item__icon--blue">
                  <Icon size={28} />
                </div>
                <div className="svc-item__body">
                  <h3>{title}</h3>
                  <p className="svc-item__desc">{desc}</p>
                  <div className="svc-item__details">
                    <h4>Alcance del servicio</h4>
                    <ul>
                      {details.map(d => (
                        <li key={d}>
                          <IconCheckCircle size={15} style={{ color: 'var(--c-blue-500)', flexShrink: 0, marginTop: 2 }} />
                          {d}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="svc-item__footer">
                    <span className="svc-norm-badge">
                      <IconPin size={14} />
                      {norm}
                    </span>
                    <Link to="/contacto" className="btn btn--blue btn--sm">Solicitar cotización</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
